import React, { useEffect, useState, useContext } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';
import { MultiSelect } from 'primereact/multiselect';

import { getNoteDetails, updateCaseNote } from 'services/CaseNoteServices';
import constants from 'constants/index';

import { toastConstant } from 'constants/toastmessage';
import { useToast } from 'context/ToastContext';
import { UserDetailsContext } from 'context/userDetailsContext';
import { findArrayDifferences, getTenantDetails, handleRedirection, sanitizeHtmlColorContent, sortByKey } from 'utils/utils';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import classNames from 'classnames';
import { GroupUserTooltip } from 'components/UI/GroupUserTooltip/GroupUserTooltip';

import { generateFullName } from 'utils/generateFullNameUtils';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { totalCountEvent } from 'services/generalServices';
import ImageComponent from 'shared/ImageComponent';

import { ReactComponent as OutgoingIcon } from 'assets/svg/outgoing_call.svg';
import { ReactComponent as IncomingIcon } from 'assets/svg/incoming_call.svg';
import { ReactComponent as FilesIcon } from 'assets/svg/files.svg';
import { listUsers } from 'services/users/userServices';
import TextSnippetWrapper from 'components/TextSnippetWrapper';
import { sanitizeHtmlContent } from 'modules/mailbox/utils/utils';
import { convertToHtml } from 'utils/utility_functions/convertToHtml';
import useAutomatedTime from 'hooks/useAutomatedTime';
import { Tag } from 'primereact/tag';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const NoteDetails = (props) => {
  const { caseDetails, getCaseDetails, isFromCaseSpecificModule, isLeadSpecific } = props;
  const { addToast } = useToast();
  const [tenantId] = getTenantDetails();
  const [resolved, setResolved] = useState(false);
  const [titleEdit, setTitleEdit] = useState(false);
  const [title, setTitle] = useState('');
  const [descriptionEdit, setDescriptionEdit] = useState(false);
  const [description, setDescription] = useState('');
  const [toggleResolution, setToggleResolution] = useState(false);
  const [resolutionEdit, setResolutionEdit] = useState(false);
  const [resolvedEdit, setResolvedEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userContext = useContext(UserDetailsContext);
  const [formError, setFormError] = useState({});

  const [firmUsersWithGroups, setFirmUsersWithGroups] = useState([]);
  const [teamMemberOptions, setTeamMemberOptions] = useState([]);
  const [teamMemberArr, setTeamMemberArr] = useState([]);
  const [oldTeamMemberArr, setOldTeamMemberArr] = useState([]);

  const [groups, setGroups] = useState([]);
  const [firmUsers, setFirmUsers] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState();

  const [areArraysEqual, setAreArraysEqual] = useState(true);
  const [userList, setUserList] = useState([]);
  const [currentData, setCurrentData] = useState('');
  const { id } = useParams();
  const location = useLocation();

  const { onMountUnMount, onOperationBreak } = useAutomatedTime(caseDetails?.case_id, caseDetails?.case_description?.case_name);

  const renderBusinessTag = (contact) => {
    if (contact?.contact_type === 'business') {
      return (
        <Tag
          className="y-tag"
          style={{ marginLeft: '4px' }}
          value={contact.contact_type.charAt(0).toUpperCase() + contact.contact_type.slice(1)}
          severity="normal"
        />
      );
    }
    return null;
  };

  const fetchData = async () => {
    try {
      const response = await getNoteDetails({ pk: location?.state?.pk, sk: location?.state?.sk, id });
      setCurrentData(response?.data);
      setTitle(response?.data?.title);
      setDescription(convertToHtml(sanitizeHtmlColorContent(response?.data?.description)));
      setToggleResolution(response?.data?.resolution_status);
      setResolved(response?.data?.resolved_status);
    } catch (err) {}
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getNoteDetails({ pk: location?.state?.pk, sk: location?.state?.sk, id });
        setCurrentData(response?.data);
        setTitle(response?.data?.title);
        setDescription(convertToHtml(sanitizeHtmlColorContent(response?.data?.description)));
        setToggleResolution(response?.data?.resolution_status);
        setResolved(response?.data?.resolved_status);
      } catch (err) {}
    };
    fetchData();
  }, [id, location?.state?.pk, location?.state?.sk]);

  useEffect(() => {
    typeof onMountUnMount === 'function' && onMountUnMount('update-note', 'mounted', caseDetails?.case_id);
    return () => {
      typeof onOperationBreak === 'function' && onOperationBreak();
    };
  }, []);

  const loadUserList = () => {
    totalCountEvent('user').then((response) => {
      listUsers({ is_include_groups: true, is_confirmed_user: true, status: 'all', limit: response.data })
        .then((response) => setUserList(response.data?.firm_users || []))
        .catch((error) => console.log(error));
    });
  };

  const ChangeCaseUserData = (data) =>
    data?.map((v) => ({
      ...v,
      label: generateFullName(v),
      value: v.client_cognito_username || v.contact_id,
    }));

  function combineUserAndGroup(response) {
    const groupedContacts = {};

    if (response?.length > 0) {
      response.forEach((element) => {
        const contactType = element.res_type === 'user-group' ? 'Groups' : 'Users';

        if (!groupedContacts[contactType]) {
          groupedContacts[contactType] = {
            label: contactType,
            items: [],
          };
        }

        if (element?.res_type === 'user-group') {
          groupedContacts[contactType].items.push({
            label: element.group_name,
            value: element.user_group_id,
            ...element,
          });
        } else {
          function generateLabel(element) {
            if (element.contact_type === 'person' || element.first_name || element.middle_name || element.last_name) {
              return generateFullName(element);
            }
            return element.title;
          }

          const label = generateLabel(element);

          groupedContacts[contactType].items.push({
            label: label,
            value: element.client_cognito_username ? element.client_cognito_username : element.contact_id,
            email: element.email,
            is_create_client_portal: element.is_create_client_portal,
            access_level: element.access_level,
            ...element,
          });
        }
      });
    }

    return Object.values(groupedContacts);
  }

  const handleTeamMemberChange = (selectedOption) => {
    setTeamMemberArr(selectedOption);
    let data = {};
    if (selectedOption && selectedOption?.length) {
      data.teamMember = false;
    } else {
      toggleResolution ? (data.teamMember = true) : (data.teamMember = false);
    }
    setFormError(data);
  };

  function onChangeAttendeesWhileEditing(newArray, oldArray) {
    const { added, removed } = findArrayDifferences(oldArray, newArray);

    const contacts = firmUsersWithGroups.reduce((arr, val) => [...arr, ...val.items], []);
    if (added?.[0]) {
      const addedContact = contacts?.find(
        (v) => (v?.client_cognito_username || v.contact_id) === added?.[0] || v?.user_group_id?.includes(added?.[0])
      );
      if (addedContact?.user_group_id) {
        const { group_name, user_group_id, sk } = addedContact;

        let updatedGroups = [
          ...groups,
          {
            group_name,
            group_id: user_group_id,
            sk: sk,
          },
        ];
        setGroups(updatedGroups);
      } else if (addedContact?.contact_id || addedContact?.client_cognito_username) {
        const contactIndex = firmUsers?.findIndex((c) => c?.team_id === addedContact?.contact_id);
        if (contactIndex !== -1) {
          return;
        } else {
          const { firm_user_id, user_id, is_confirmed, status } = addedContact;

          let new_users = [
            ...firmUsers,
            {
              team_id: user_id,
              team_member_name: generateFullName(addedContact),
              firm_user_id,
              is_confirmed,
              status,
            },
          ];
          setFirmUsers(new_users);
        }
      }
    }
    if (removed?.[0]) {
      const removedContact = contacts?.find(
        (v) => (v?.client_cognito_username ?? v.contact_id) === removed?.[0] || v?.user_group_id?.includes(removed?.[0])
      );
      if (removedContact?.user_group_id) {
        let updatedGroups = groups?.filter((g) => g.group_id !== removedContact.user_group_id);
        setGroups(updatedGroups);
      } else if (removedContact?.contact_id) {
        const newArray = [];

        firmUsers.forEach((item) => {
          if (item?.team_id === removedContact?.user_id && !item?.user_group_id) {
            // Skip this item, effectively removing it
            return;
          }

          if (item?.contact_id === removedContact?.contact_id && item?.user_group_id) {
            newArray.push(item);
          }
        });
        setFirmUsers(newArray);
      }
    }
  }

  const getCreated = () => {
    let rowData = currentData;

    let res = `Created: ${convertDateFromApiToUserTimezone(
      rowData?.created_time,
      userContext?.userDetails?.timezone,
      // rowData.time,
      constants.month_date_year_time_12_format
    )}`;
    return res;
  };

  const getUpdated = () => {
    let rowData = currentData;
    let res = `Updated: ${convertDateFromApiToUserTimezone(
      rowData?.time,
      userContext?.userDetails?.timezone,
      // rowData.last_updated_time,
      constants.month_date_year_time_12_format
    )}`;
    return res;
  };

  const cancelEdit = () => {
    setDescriptionEdit(false);
    setTitleEdit(false);
    setResolutionEdit(false);
    setResolvedEdit(false);
    if (currentData) {
      if (currentData.description) {
        setDescription(convertToHtml(sanitizeHtmlColorContent(currentData.description)));
      }
      if (currentData.title) {
        setTitle(currentData.title);
      }
      if (currentData.resolution_status) {
        setToggleResolution(true);
      } else {
        setToggleResolution(false);
      }
      if (currentData.resolved_status) {
        setResolved(true);
      } else {
        setResolved(false);
      }
      setTeamMemberArr(oldTeamMemberArr);
      setFormError({});
    }
  };

  const getSelectedCaseUsers = (e) => {
    let teamMembers = teamMemberArr?.flatMap((val) => {
      const fullData = teamMemberOptions?.find((item) => {
        return item.value === val;
      });

      if (!fullData) {
        return [];
      }

      return [
        {
          team_id: fullData?.value,
          team_member_name: fullData?.label,
          firm_user_id: fullData?.firm_user_id,
        },
      ];
    });

    return teamMembers;
  };

  function navigateToModule(item, module) {
    let url = '/';
    if (module === 'group') {
      url = '/settings/groups';
    } else if (module === 'user') {
      url = item?.created_by_firm_user_id ? `/settings/team-management/${item?.created_by_firm_user_id}` : '/settings/team-management';
    } else if (module === 'call_for') {
      url = item?.team_id ? `/settings/team-management/${item?.team_id}` : '/settings/team-management';
    } else if (module === 'assignees') {
      url = item?.firm_user_id ? `/settings/team-management/${item?.firm_user_id}` : '/settings/team-management';
    } else if (module === 'client') {
      url = item ? `/contacts/${item}` : '/contacts';
    }
    return url;
    // handleRedirection(history, url);
  }

  const updateCaseNoteDetails = () => {
    let data = JSON.parse(JSON.stringify(currentData));
    if (descriptionEdit || titleEdit || resolutionEdit || resolvedEdit || !areArraysEqual) {
      if (toggleResolution && teamMemberArr?.length === 0) {
        let data = {};
        data.teamMember = true;
        setFormError(data);
        return;
      }

      setIsLoading(true);
      if (data.description !== description) {
        data.description = description;
      }

      if (data.title !== title) {
        data.title = title;
      }

      if (data.resolution_status !== toggleResolution) {
        data.resolution_status = toggleResolution;
      }

      if (data.resolved_status !== resolved) {
        data.resolved_status = resolved;
      }
      data.resolution_status = toggleResolution;

      if (currentData.note_type === 'case_note') {
        data.groups = groups;
        data.firm_user = firmUsers;
      }

      if (currentData.note_type === 'call_log') {
        data.firm_user = getSelectedCaseUsers();
      }

      if (data?.groups?.length > 0) {
        data.groups = data.groups?.map((group) => {
          const { firm_user_data, ...groupWithoutFirmUserData } = group;
          return groupWithoutFirmUserData;
        });
      }

      updateCaseNote(data, props.isLeadSpecific)
        .then(() => {
          typeof onMountUnMount === 'function' && onMountUnMount('update-note', 'unmounted', data?.case_id);
          setIsLoading(false);
          fetchData().then(() => {
            setTitleEdit(false);
            setDescriptionEdit(false); // Set description edit to false after fetching data
            setResolutionEdit(false);
            setResolvedEdit(false);
            if (isFromCaseSpecificModule || isLeadSpecific) {
              getCaseDetails();
            }
          });
          handleTeamMembers();
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.NOTE_UPDATED_CREATED);
        })
        .catch(() => {
          setIsLoading(false);
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.NOTE_UPDATED_FAILED);
        });
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (currentData?.note_type === 'case_note' || currentData?.note_type === 'call_log') {
      const oldIDs = oldTeamMemberArr?.map((member) => member).sort();
      const newIDs = teamMemberArr?.map((member) => member).sort();
      const areEqual = JSON.stringify(newIDs) === JSON.stringify(oldIDs);
      setAreArraysEqual(areEqual);
    }
  }, [oldTeamMemberArr, teamMemberArr]);

  useEffect(() => {
    if (currentData) {
      if (currentData?.description) {
        setDescription(convertToHtml(sanitizeHtmlColorContent(currentData.description)));
      }
      if (currentData?.title) {
        setTitle(currentData?.title);
      }
      if (currentData?.resolution_status) {
        setToggleResolution(true);
      }
      if (currentData?.resolved_status) {
        setResolved(true);
      }
    }
    loadUserList();
  }, []);

  useEffect(() => {
    if (userList?.length) {
      if (currentData?.note_type === 'case_note') {
        let combined_data = combineUserAndGroup(filteredUserList);
        const sortedList = combined_data?.map((item) =>
          item?.label === 'Users' ? { ...item, items: sortByKey(item.items, 'first_name') } : item
        );
        setFirmUsersWithGroups(sortedList);

        let firm_users = currentData?.firm_user || [];
        let groups = currentData?.groups?.filter((v) => v?.group_id) || [];

        let individualUsers = firm_users;
        let individualUserTeamIds = individualUsers?.map((v) => v?.team_id);

        let selected_items = [...individualUserTeamIds, ...groups?.map((v) => v?.group_id)];
        setTeamMemberArr(selected_items ?? []);
        setOldTeamMemberArr(selected_items ?? []);
        setFirmUsers(firm_users ?? []);
        setGroups(groups ?? []);
      } else if (currentData.note_type === 'call_log') {
        const filterDataWithoutGroups = userList?.filter((item) => item?.res_type === 'user');
        let x = ChangeCaseUserData(filterDataWithoutGroups);
        const sortedList = sortByKey(x, 'first_name');
        setTeamMemberOptions(sortedList);
        let firm_users = currentData.firm_user;
        let selected_items = firm_users?.map((v) => v?.team_id);
        setTeamMemberArr(selected_items ?? []);
        setOldTeamMemberArr(selected_items ?? []);
      }
    } else {
      setFirmUsersWithGroups([]);
      setTeamMemberOptions([]);
    }
  }, [userList, currentData, filteredUserList]);

  const handleTeamMembers = () => {
    totalCountEvent('user').then((response) => {
      listUsers({ is_include_groups: true, is_confirmed_user: true, status: '', limit: response.data })
        .then((response) => setUserList(response.data?.firm_users || []))
        .catch((error) => console.log(error));
    });

    if (userList?.length) {
      if (currentData?.note_type === 'case_note') {
        let combined_data = combineUserAndGroup(userList);
        setFirmUsersWithGroups(combined_data);

        let firm_users = currentData?.firm_user || [];
        let groups = currentData?.groups?.filter((v) => v?.group_id) || [];

        let individualUsers = firm_users;
        let individualUserTeamIds = individualUsers?.map((v) => v?.team_id);

        let selected_items = [...individualUserTeamIds, ...groups?.map((v) => v?.group_id)];
        setTeamMemberArr(selected_items ?? []);
        setOldTeamMemberArr(selected_items ?? []);
        setFirmUsers(firm_users ?? []);
        setGroups(groups ?? []);
      } else if (currentData.note_type === 'call_log') {
        const filterDataWithoutGroups = userList?.filter((item) => item?.res_type === 'user');
        let x = ChangeCaseUserData(filterDataWithoutGroups);
        setTeamMemberOptions(x);
        let firm_users = currentData.firm_user;
        let selected_items = firm_users?.map((v) => v?.team_id);
        setTeamMemberArr(selected_items ?? []);
        setOldTeamMemberArr(selected_items ?? []);
      }
    } else {
      setFirmUsersWithGroups([]);
      setTeamMemberOptions([]);
    }
  };

  useEffect(() => {
    if (userList && currentData) {
      let finalUserList = userList.filter(
        (group) =>
          (group?.res_type === 'user-group' && group?.status === 'ARCHIVED' && currentData?.group_list?.includes(group?.user_group_id)) ||
          group?.status === 'ACTIVE' ||
          group?.res_type !== 'user-group'
      );
      setFilteredUserList(
        finalUserList.filter((user) => {
          // If user_group_id is present, include the user directly
          if (user.hasOwnProperty('user_group_id')) {
            return true;
          } else {
            const isActive = user.status === 'ACTIVE' && user.is_confirmed;
            const isArchivedConfirmed = user.status === 'ARCHIVED' || user.is_confirmed === false;

            const isIndividualUser = currentData?.firm_user?.some((firmUser) => firmUser?.team_id === user?.client_cognito_username);
            return isActive || (isArchivedConfirmed && isIndividualUser);
          }
        })
      );
    }
  }, [userList, currentData]);

  const assignToItemTemplate = (option) => {
    if (option?.res_type === 'user' && option?.is_confirmed === false && option?.status === 'ACTIVE') {
      return (
        <>
          {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${option?.label} (Unconfirmed)`}
        </>
      );
    } else if (option?.res_type === 'user' && option?.is_confirmed && option?.status === 'ARCHIVED') {
      return (
        <>
          {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${option?.label} (Inactive)`}
        </>
      );
    } else if (option?.res_type === 'user' && option?.is_confirmed === false && option?.status === 'ARCHIVED') {
      return (
        <>
          {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${option?.label} (Inactive)`}
        </>
      );
    } else if (option?.res_type === 'user-group' && option?.status === 'ARCHIVED') {
      return (
        <>
          {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
          {`${option?.label} (Inactive)`}
        </>
      );
    }
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {option?.label}
      </>
    );
  };

  const assignToCallLogItemTemplate = (option) => {
    return (
      <>
        {option?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
        {option?.label}
      </>
    );
  };

  const getStatusLabel = (option) => {
    if (option) {
      if (option?.is_confirmed === false && (option?.status === 'ACTIVE' || option?.status === undefined)) {
        return '(Unconfirmed)';
      } else if ((option?.is_confirmed || option?.is_confirmed === undefined) && option?.status === 'ARCHIVED') {
        return '(Archived)';
      } else if (option?.is_confirmed === false && option?.status === 'ARCHIVED') {
        return '(Archived)';
      }
    }
    return '';
  };

  return (
    <React.Fragment>
      <GlobalLoader />
      {currentData?.case_note_id && (
        <React.Fragment>
          <div className="row mb-4">
            <div className="col-sm-12">
              <Link
                to={`/${props.isLeadSpecific ? 'leads' : 'cases'}/${props?.caseDetails?.case_id}/${
                  props.isLeadSpecific ? 'note' : 'notes'
                }`}
              >
                <i className="fas fa-arrow-left pointer"></i>
              </Link>

              <span style={{ marginLeft: '0.5rem' }}>Go Back to Notes List</span>
            </div>
          </div>
          <div className="p-card card-bg p-3 me-3 mb-4">
            <div className="p-card-body">
              <div className="p-card-content pt-0">
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2 pb-3 border-bottom-dark">
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="d-block">
                      <div className="d-flex align-items-center">
                        {titleEdit ? (
                          <>
                            <TextSnippetWrapper
                              type="text"
                              className=" rounded flex-grow-1 w-75"
                              placeholder="Title"
                              value={title}
                              onChange={(e) => {
                                setTitle(e.target.value);
                              }}
                              name="title"
                            />
                            <span
                              onClick={(e) => {
                                setTitleEdit(!titleEdit);
                              }}
                              className="pointer px-2"
                            >
                              <i className="pi pi-times-circle"></i>
                            </span>
                          </>
                        ) : (
                          <div
                            onClick={(e) => {
                              setTitleEdit(!titleEdit);
                            }}
                            className=" d-flex align-items-center flex-wrap"
                          >
                            <div className="d-flex align-items-center">
                              <div>
                                {currentData && currentData.note_type === 'case_note' ? (
                                  <FilesIcon width={18} height={18} className="me-2" />
                                ) : currentData.note_type === 'call_log' && currentData.call_type === 'outgoing' ? (
                                  <OutgoingIcon width={18} height={18} className="me-2" />
                                ) : currentData.note_type === 'call_log' && currentData.call_type === 'incoming' ? (
                                  <IncomingIcon width={18} height={18} className="me-2" />
                                ) : null}
                              </div>
                              <h5 className="mb-0 text-bold">{currentData && currentData.title ? currentData.title : '-'} </h5>
                            </div>
                            {renderBusinessTag(currentData?.called_by)}
                            {renderBusinessTag(currentData?.person_called)}
                          </div>
                        )}
                      </div>
                    </div>
                    {currentData.resolution_status && !currentData.resolved_status ? (
                      <div className="blue-tag ms-3">
                        <p className="blue-tag-value">Needs Resolution</p>
                      </div>
                    ) : currentData.resolved_status ? (
                      <div className="green-tag ms-3">
                        <p className="green-tag-value">Resolved</p>
                      </div>
                    ) : null}
                  </div>
                  <div className="d-flex align-items-center">
                    {descriptionEdit || titleEdit || resolutionEdit || resolvedEdit || !areArraysEqual ? (
                      <>
                        <Button
                          type="button"
                          label="Save"
                          className="p-button p-button-secondary"
                          onClick={updateCaseNoteDetails}
                          loading={isLoading}
                        />
                        <Button type="button" label="Cancel" className="p-button p-button-sec ms-2" onClick={cancelEdit} />
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                  <Link to={navigateToModule(currentData, 'user')} className="text-decoration-none">
                    <div className="d-flex align-items-center mb-1 p-avatar-clickable">
                      <div>
                        <ImageComponent
                          filePath={`${tenantId}/${currentData?.created_by_firm_user_id}/profile_image`}
                          fileName={currentData?.created_by_name?.['first_name']}
                          fileSize="small.jpg"
                        />
                      </div>
                      <div className="d-flex flex-column">
                        <span className="text-decoration-none text-primary-dark text-bold case-details-link">
                          {currentData?.created_by_firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                          {currentData.created_by_name?.first_name} {currentData.created_by_name?.last_name}
                        </span>
                        {/* <span className="F-size12 black-500">Client</span> */}
                      </div>
                    </div>
                  </Link>

                  <div>
                    <p className="F-size14 mb-1">{getCreated()}</p>
                    <p className="F-size14">{getUpdated()}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center filter-wrap justify-content-between flex-wrap mb-2 px-3 py-2 gap-2">
                  {/* {currentData?.note_type === 'case_note' ? ( */}
                  {currentData?.note_type === 'case_note' ? (
                    <div className="d-flex align-items-center py-2 case-notes-assign mw-100">
                      <div className="p-medium me-2">Assign to Firm User {toggleResolution && <span className="alert-star"> *</span>}</div>
                      <div className="w-100">
                        <MultiSelect
                          value={firmUsersWithGroups?.length ? teamMemberArr : []}
                          onChange={(e) => {
                            onChangeAttendeesWhileEditing(e.value, teamMemberArr);
                            handleTeamMemberChange(e.value);
                          }}
                          display="chip"
                          className="input-shadow w-100 F-size14 input-width"
                          filter
                          placeholder="Select a Firm User"
                          options={firmUsersWithGroups ?? []}
                          optionValue={'value'}
                          optionLabel="label"
                          optionGroupLabel="label"
                          optionGroupChildren="items"
                          itemTemplate={assignToItemTemplate}
                          selectedItemTemplate={(val) => {
                            if (!val || (Array.isArray(val) && val.length === 0) || val === null || val === undefined || val === '') {
                              return null;
                            }
                            try {
                              const flatOptions = (firmUsersWithGroups || []).flatMap((g) => g.items || []);
                              const opt = flatOptions.find((o) => o?.value === (val?.value ?? val));
                              if (!opt) return <span>{val?.label || val}</span>;
                              const isGroup = opt?.res_type === 'user-group' || opt?.user_group_id;

                              const currentIndex = teamMemberArr?.findIndex((item) => (item?.value ?? item) === (val?.value ?? val));
                              const isLastItem = currentIndex === teamMemberArr?.length - 1;

                              if (!isGroup)
                                return (
                                  <span>
                                    {opt?.label}
                                    {!isLastItem && <span>, </span>}
                                  </span>
                                );
                              const safeId = String(opt?.value || '')?.replace(/[^a-zA-Z0-9_-]/g, '');
                              const cls = `note-group-chip-${safeId}`;
                              // Prefer the group object from view-case-note-details (currentData.groups) for firm_user_data
                              const groupFromDetails = (currentData?.groups || []).find(
                                (g) => g?.group_id === opt?.user_group_id || g?.group_id === opt?.value
                              );
                              return (
                                <>
                                  <span className={cls}>
                                    {opt?.label}
                                    {!isLastItem && <span>, </span>}
                                  </span>
                                  <Tooltip target={`.${cls}`} position="top">
                                    {GroupUserTooltip(groupFromDetails || opt, currentData?.firm_user)}
                                  </Tooltip>
                                </>
                              );
                            } catch (e) {
                              return <span>{val?.label || val}</span>;
                            }
                          }}
                          emptyFilterMessage="No records found"
                          showSelectAll={false}
                          name="team_member"
                        />
                        {toggleResolution && formError && formError.teamMember && <span style={{ color: '#dc3545' }}>Required</span>}
                      </div>
                    </div>
                  ) : null}
                  {currentData?.note_type === 'call_log' ? (
                    <div className="d-flex align-items-center py-2 case-notes-assign mw-100">
                      <div className="me-2 p-medium text-nowrap">
                        Assign to Firm User {toggleResolution && <span className="alert-star"> *</span>}
                      </div>
                      <div className="w-100">
                        <MultiSelect
                          value={teamMemberOptions?.length ? teamMemberArr : []}
                          placeholder="Select"
                          onChange={(e) => handleTeamMemberChange(e.value)}
                          display="chip"
                          className="input-shadow w-100"
                          filter
                          options={teamMemberOptions ?? []}
                          optionLabel="label"
                          optionValue="value"
                          emptyFilterMessage="No records found"
                          showSelectAll={false}
                          name="team_member"
                          itemTemplate={assignToCallLogItemTemplate}
                        />
                        {toggleResolution && formError && formError.teamMember && <span style={{ color: '#dc3545' }}>Required</span>}
                      </div>
                    </div>
                  ) : null}
                  <div className="d-flex align-items-center justify-content-end required-switch">
                    {currentData && currentData.resolution_status ? (
                      <>
                        <label className="ps-2 p-medium align-items-center d-flex me-2">Resolved</label>
                        <InputSwitch
                          onChange={(e) => {
                            setResolved(e.value);
                            setResolvedEdit(!resolvedEdit);
                          }}
                          checked={resolved}
                        />
                      </>
                    ) : (
                      <>
                        <label className="ps-2 p-medium align-items-center d-flex me-2">Needs Resolution</label>
                        <InputSwitch
                          onChange={(e) => {
                            setToggleResolution(e.value);
                            setResolutionEdit(!resolutionEdit);
                          }}
                          checked={toggleResolution}
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="row gy-2">
                  <div className="col-md-8 col-12 d-flex mb-1 position-relative">
                    {descriptionEdit ? (
                      <div className="create-msg-popup w-100">
                        <TextSnippetWrapper
                          type="editor"
                          className="rounded flex-grow-1 w-100 case-note-area email-quill-editor rounded-3"
                          placeholder="Description"
                          value={sanitizeHtmlColorContent(description)}
                          onChange={(e) => {
                            setDescription(convertToHtml(sanitizeHtmlColorContent(e)));
                          }}
                          name="description"
                          autoResize
                        />
                        <span
                          onClick={(e) => {
                            setDescriptionEdit(!descriptionEdit);
                          }}
                          className="pointer px-2"
                          style={{ position: 'absolute', right: '15px', top: '10px' }}
                        >
                          <i className="pi pi-times-circle F-size20"></i>
                        </span>
                      </div>
                    ) : (
                      <div className="card-bg card p-2 pe-3 ps-3 w-100 shadow-sm">
                        <div
                          className="case-note-text"
                          onClick={(e) => {
                            setDescriptionEdit(!descriptionEdit);
                          }}
                          dangerouslySetInnerHTML={sanitizeHtmlContent(sanitizeHtmlColorContent(currentData?.description || ''))}
                        ></div>
                      </div>
                    )}
                  </div>
                  {userContext.getPermission('cases') === constants.permissions.WRITE && (
                    <div className="col-md-4 col-12  mb-1">
                      <div className="case-notes-details p-3">
                        {currentData && currentData.note_type === 'call_log' && (
                          <>
                            <div className="d-flex vertical-align-middle text-align-center my-2">
                              <span className="text-medium">Call type : </span> <span className="mx-1">{currentData.call_type}</span>
                            </div>{' '}
                          </>
                        )}
                        {currentData?.note_type === 'call_log' && currentData?.call_type === 'incoming' && (
                          <>
                            <div className="my-2">
                              <span className="text-medium">Call For : </span>
                              {currentData?.call_for?.map((item, index, array) => (
                                <Link to={navigateToModule(item, 'call_for')} className="text-decoration-none" key={index}>
                                  <span key={index} className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                    {item?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                                    {` ${item?.team_member_name}`}
                                    {index !== array.length - 1 ? ', ' : ''}
                                  </span>
                                </Link>
                              ))}
                            </div>

                            {currentData?.called_by?.contact_type === 'business' ? (
                              <div>
                                <div className="my-2">
                                  <span className="text-medium">Business Name : </span>
                                  <Link
                                    to={navigateToModule(
                                      currentData?.called_by ? currentData?.called_by?.client_id : currentData?.caller_name?.client_id,
                                      'client'
                                    )}
                                    className="text-decoration-none"
                                  >
                                    <span className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                      {` ${
                                        currentData?.called_by ? currentData?.called_by?.client_name : currentData?.caller_name?.client_name
                                      }`}
                                    </span>
                                  </Link>
                                </div>
                                <div className="my-2">
                                  <span className="text-medium">Caller Name : </span>
                                  <span className="F-size14 text-decoration-none">
                                    {` ${currentData?.caller_name && currentData?.caller_name}`}
                                  </span>
                                </div>
                              </div>
                            ) : (
                              <div className="my-2">
                                <span className="text-medium">Caller Name : </span>
                                <Link
                                  to={navigateToModule(
                                    currentData?.called_by ? currentData?.called_by?.client_id : currentData?.caller_name?.client_id,
                                    'client'
                                  )}
                                  className="text-decoration-none"
                                >
                                  <span className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                    {` ${
                                      currentData?.called_by ? currentData?.called_by?.client_name : currentData?.caller_name?.client_name
                                    }`}
                                  </span>
                                </Link>
                              </div>
                            )}
                          </>
                        )}
                        {currentData?.note_type === 'call_log' && currentData?.call_type === 'outgoing' && (
                          <>
                            {currentData?.person_called?.contact_type === 'business' ? (
                              <div>
                                <div className="my-2">
                                  <span className="text-medium">Business Name : </span>
                                  <Link
                                    to={navigateToModule(currentData?.person_called?.client_id, 'client')}
                                    className="text-decoration-none"
                                  >
                                    <span className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                      {` ${currentData?.person_called?.client_name || ''}`}
                                    </span>
                                  </Link>
                                </div>
                                <div className="my-2">
                                  <span className="text-medium">Caller Name : </span>
                                  <span className="F-size14 text-decoration-none">{` ${currentData?.caller_name || ''}`}</span>
                                </div>
                              </div>
                            ) : (
                              <div className="my-2">
                                <span className="text-medium">Caller Name : </span>
                                <Link
                                  to={navigateToModule(currentData?.person_called?.client_id, 'client')}
                                  className="text-decoration-none"
                                >
                                  <span className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                    {` ${currentData?.person_called?.client_name || ''}`}
                                  </span>
                                </Link>
                              </div>
                            )}
                          </>
                        )}
                        {currentData?.note_type === 'call_log' ? (
                          <div className="my-2">
                            <span className="text-medium">Phone Number : </span>
                            <span className="F-size14 text-decoration-none pointer">{currentData?.phone_number}</span>
                          </div>
                        ) : null}
                        <div className="my-2">
                          <span className="text-medium">Assignees : </span>

                          {currentData?.note_type === 'case_note' ? (
                            <>
                              {currentData?.groups?.map((group, index, array) => (
                                <Link
                                  to={group?.group_status !== 'Deleted' && navigateToModule(group, 'group')}
                                  className="text-decoration-none"
                                >
                                  <span
                                    key={index}
                                    className={classNames({
                                      'F-size14 text-primary-dark text-decoration-none case-details-link pointer': true,
                                      'disabled-element': group?.group_status === 'Deleted',
                                      ['name-' + index]: true,
                                    })}
                                  >
                                    {` ${group?.group_name} (Group${
                                      group?.group_status === 'ARCHIVED'
                                        ? ' - Archived'
                                        : group?.group_status === 'Deleted'
                                        ? ' - Deleted'
                                        : ''
                                    })`}

                                    {index !== array.length - 1 && (
                                      <>,&nbsp;</> // Add a comma and space if not the last element
                                    )}

                                    {index === array.length - 1 && currentData?.firm_user?.length > 0 && (
                                      <>,&nbsp;</> // Add a comma and space if not the last element
                                    )}

                                    <Tooltip target={`.name-${index}`} position="top">
                                      {GroupUserTooltip(group, currentData?.firm_user)}
                                    </Tooltip>
                                  </span>
                                </Link>
                              ))}
                              {currentData?.firm_user?.map((item, index, array) => (
                                <Link to={navigateToModule(item, 'assignees')} className="text-decoration-none" key={index}>
                                  <span key={index} className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                    {item?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                                    {` ${item?.team_member_name} `}
                                    {getStatusLabel(item)}

                                    {index !== array.length - 1 ? ',' : ''}
                                  </span>
                                </Link>
                              ))}

                              {!currentData?.groups_list && !currentData?.firm_user && <span>Not Assigned</span>}
                            </>
                          ) : currentData?.note_type === 'call_log' ? (
                            <>
                              {currentData?.firm_user?.map((item, index, array) => (
                                <Link to={navigateToModule(item, 'assignees')} className="text-decoration-none">
                                  <span key={index} className="F-size14 text-primary-dark text-decoration-none case-details-link pointer">
                                    {item?.firm_user_id && <i className="fas fa-user-tie me-2"></i>}
                                    {` ${item?.team_member_name}`}
                                    {index !== array.length - 1 ? ',' : ''}
                                  </span>
                                </Link>
                              ))}
                              {!currentData?.firm_user || currentData?.firm_user?.length === 0 ? <span>Not Assigned</span> : null}
                            </>
                          ) : null}
                        </div>
                        {currentData?.note_type === 'call_log' && (
                          <>
                            {((currentData?.call_type === 'incoming' && currentData?.called_by?.contact_type === 'business') ||
                              (currentData?.call_type === 'outgoing' && currentData?.person_called?.contact_type === 'business')) && (
                              <div className="my-2">
                                <span className="text-medium">Extension : </span>
                                <span className="F-size14 text-decoration-none">{currentData?.contact_extension || ''}</span>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-8">
                <div className="text-end pe-5"></div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default NoteDetails;
